import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import Pagination from "../../../Components/layouts/pagination";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useSelector } from "react-redux";
import AllsalaryTable from "./all_employee_salary_table";
import downloadCSV from "../../../Components/Functions/download.csv";
import axios from "axios";
// import { FcLandscape } from "react-icons/fc";
// import SiUpdateTable from "./view_si_table";
// import { FcKindle } from "react-icons/fc";

const AllEmployeeSalary = () => {
  const getPreviousMonth = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 1);
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    return `${year}-${month}`;
  };
  const payroleCred = useSelector((store) => store.payroleReducer.cred);
  const [refresh, setRefresh] = useState(false);
  const store = useSelector((store) => store.login.user);
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [generatedBy, setGeneratedBy] = useState([]);
  //   const [months, setMonth] = useState(getPreviousMonth());
  const [username, setUserName] = useState("Pranoti Shinde");
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from({ length: 2040 - 2024 + 1 }, (_, i) => 2024 + i);

  const [filters, setFilters] = useState({
    userName: "",
    month: "",
    year: "",
  });

  useEffect(() => {
    // performRequest(
    //   "GET",
    //   getFilteredURL("/employeeManagement/allEmployeeSalary/", page, filters)
    // )
    axios
      .get(
        getFilteredURL(
          "https://payroll-817182422433.asia-south1.run.app/employeeManagement/allEmployeeSalary/",
          page,
          filters
        ),
        { headers: payroleCred }
      )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.allEmployeeSalary);
          // console.log(res);
          setTotalPages(Math.ceil(res?.data?.allEmployeeSalaryCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
    // .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", "/employeeManagement/getActiveEmployeeList")
      .then((res) => setGeneratedBy(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handleDownloadCSV = () => {
    axios
      .get(
        getFilteredURL(
          "https://payroll-817182422433.asia-south1.run.app/employeeManagement/allEmployeeSalary/",
          page,
          filters
        ),
        { headers: payroleCred }
      )
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.allEmployeeSalary.length > 0) {
            let data = res.data?.allEmployeeSalary;
            let newData = data?.map((el) => {
              let paybleSalary = 0;
              if (el?.paybleSalary) {
                paybleSalary += +el?.paybleSalary;
              }
              if (el?.salaryAdjust?.ammount && el?.salaryAdjust?.type) {
                el?.salaryAdjust?.type === "addition"
                  ? (paybleSalary += +el?.salaryAdjust?.ammount)
                  : (paybleSalary -= +el?.salaryAdjust?.ammount);
              }

              return {
                Employee_Id: el?.employeeData?.id || "---",
                Month: el?.month || "---",
                Employee_Name:
                  el.employeeData.firstName + el.employeeData.lastName || "---",
                Salary_Per_Month:
                  el?.salaryData?.salaryPerMonth ??
                  el?.employeeData?.salaryPerMonth ??
                  "---",
                T_Days_In_Month: el?.monthTotalDays || "---",
                T_Payable_Days: el?.totalPayableDays || "---",
                Incentive: el?.incentiveEmployee || "---",
                PT_Deductions:
                  el?.salaryData?.ptDeductionPerMonth ??
                  el?.employeeData?.pfptDeduction ??
                  "---",
                PF_Deduction: el?.salaryData?.pfDeductionPerMonth ?? "---",
                TDS: el?.salaryData?.tdsPerYear ?? "---",
                ESIC_Employee: el?.salaryData?.esicEmployeePerMonth ?? "---",
                ESIC_Employer: el?.salaryData?.esicEmployerPerMonth ?? "---",
                Leaves_In_Month: el?.totalLeavsDays,
                Paid_Leaves: el?.applicablePaidLeaves,
                Salary_Adjust_Type: el.salaryAdjust?.type || "---",
                Salary_Adjust_Ammount: el.salaryAdjust?.ammount || 0,
                Penulty_leaves: el?.penultyCount || 0,
                Penulty_Amt_Deduction:
                  +el?.penultyCount * +el?.perDaySalary || 0,
                Total_Salary: paybleSalary || el?.paybleSalary || "---",
              };
            });

            downloadCSV(newData, "Salary-Details");
          } else {
            Toast("error", "no data found!");
          }
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    {/* <FcKindle className="fs-2  me-1" /> */}
                    All Employee Salary
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block ">
                    <button
                      onClick={handleDownloadCSV}
                      className="btn btn-primary w-100 "
                    >
                      DOWNLOAD CSV
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search employee:"
                                  onChange={(e) => {
                                    const { value } = e.target;
                                    setFilters((prevFilters) => ({
                                      ...prevFilters,
                                      userName: value,
                                    }));
                                    setUserName(value);
                                  }}
                                  value={filters.userName}
                                >
                                  <option value="">select all</option>
                                  {store.Role ===
                                    process.env.REACT_APP_ROLE_ADMIN_S ||
                                  store.Role ===
                                    process.env.REACT_APP_ROLE_HR ||
                                  store.Role ===
                                    process.env.REACT_APP_ROLE_ADMIN ||
                                  store.Role ===
                                    process.env.REACT_APP_ROLE_ACCOUNTS ? (
                                    generatedBy &&
                                    generatedBy.map((state, index) => (
                                      <option
                                        key={index}
                                        value={state?.userName}
                                      >
                                        {state?.userName}
                                      </option>
                                    ))
                                  ) : (
                                    <option value={store.Name}>
                                      {store.Name}
                                    </option>
                                  )}
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Month:"
                                  onChange={(e) => {
                                    const { value } = e.target;
                                    setFilters((prevFilters) => ({
                                      ...prevFilters,
                                      month: value,
                                    }));
                                  }}
                                  value={filters.month}
                                >
                                  <option value="">select all</option>
                                  {store.Role ===
                                    process.env.REACT_APP_ROLE_ADMIN_S ||
                                  store.Role ===
                                    process.env.REACT_APP_ROLE_HR ||
                                  store.Role ===
                                    process.env.REACT_APP_ROLE_ADMIN ||
                                  store.Role ===
                                    process.env.REACT_APP_ROLE_ACCOUNTS ? (
                                    months &&
                                    months.map((state, index) => (
                                      <option key={index} value={state}>
                                        {state}
                                      </option>
                                    ))
                                  ) : (
                                    <option value={store.Name}>
                                      {store.Name}
                                    </option>
                                  )}
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Year:"
                                  onChange={(e) => {
                                    const { value } = e.target;
                                    setFilters((prevFilters) => ({
                                      ...prevFilters,
                                      year: value,
                                    }));
                                  }}
                                  value={filters.year}
                                >
                                  <option value="">select all</option>
                                  {years.map((state, index) => (
                                    <option key={index} value={state}>
                                      {state}
                                    </option>
                                  ))}
                                </DynamicFilterSelect>
                              </div>
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        userName: "",
                                        month: "",
                                        year: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search employee:"
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setFilters((prevFilters) => ({
                                    ...prevFilters,
                                    userName: value,
                                  }));
                                  setUserName(value);
                                }}
                                value={filters.userName}
                              >
                                <option value="">select all</option>
                                {store.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN_S ||
                                store.Role === process.env.REACT_APP_ROLE_HR ||
                                store.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN ||
                                store.Role ===
                                  process.env.REACT_APP_ROLE_ACCOUNTS ? (
                                  generatedBy &&
                                  generatedBy.map((state, index) => (
                                    <option key={index} value={state?.userName}>
                                      {state?.userName}
                                    </option>
                                  ))
                                ) : (
                                  <option value={store.Name}>
                                    {store.Name}
                                  </option>
                                )}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Month:"
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setFilters((prevFilters) => ({
                                    ...prevFilters,
                                    month: value,
                                  }));
                                }}
                                value={filters.month}
                              >
                                <option value="">select all</option>
                                {store.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN_S ||
                                store.Role === process.env.REACT_APP_ROLE_HR ||
                                store.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN ||
                                store.Role ===
                                  process.env.REACT_APP_ROLE_ACCOUNTS ? (
                                  months &&
                                  months.map((state, index) => (
                                    <option key={index} value={state}>
                                      {state}
                                    </option>
                                  ))
                                ) : (
                                  <option value={store.Name}>
                                    {store.Name}
                                  </option>
                                )}
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Year:"
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setFilters((prevFilters) => ({
                                    ...prevFilters,
                                    year: value,
                                  }));
                                }}
                                value={filters.year}
                              >
                                <option value="">select all</option>
                                {years.map((state, index) => (
                                  <option key={index} value={state}>
                                    {state}
                                  </option>
                                ))}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        userName: "",
                                        month: "",
                                        year: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    <AllsalaryTable
                      data={data}
                      currentPage={page}
                      itemsPerPage={50}
                    />

                    <div className="btn-list justify-content-center">
                      {/* <div className="d-lg-none d-md-none mt-3 mb-3">
                        <ButtonWithSVG
                          href={"/farm-training/new"}
                          buttonText="New Farm Training"
                          svg={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          }
                        />
                      </div> */}
                    </div>

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.allEmployeeSalaryCount?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AllEmployeeSalary;
